import I18nLoader from '../I18nLoader';
import { RECEIVE_LOCALE, RECEIVE_SESSION } from '../constants';

const initialState = {
  isLoading: true
};

export default function i18n(state = initialState, action) {
  switch (action.type) {
    case RECEIVE_LOCALE: {
      var locale = action.locale;
      //use session locale when page is refreshed
      if (
        typeof state.session !== 'undefined' &&
        action.locale !== state.session.locale
      ) {
        locale = state.session.locale;
      }
      const loader = new I18nLoader(locale);
      return {
        ...state,
        isLoading: false,
        locale: loader.locale,
        messages: loader.messages
      };
    }
    case RECEIVE_SESSION: {
      if (action.data === null) {
        return {
          ...state,
          session: { userId: 1, currentMemberId: 1, locale: action.locale }
        };
      }
      return {
        ...state,
        session: {
          userId: action.data.user_id,
          currentMemberId: action.data.mid,
          locale: action.data.locale,
          cToken: action.data['Content Selection']?.csrf,
          experimentCsrfToken: action.data['Content Testing']?.csrf
        }
      };
    }
    default: {
      return state;
    }
  }
}
